<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<epg-content-header [title]="title">
  <mat-spinner *ngIf="showSpinner" [diameter]="30" class="header-spinner"></mat-spinner>
  <oneapp-button
    *ngIf="customButtonConfig"
    [id]="customButtonConfig.id"
    [action]="buttonAction.CUSTOM"
    [text]="customButtonConfig.text ?? ''"
    (buttonClick)="onClick(customButtonConfig.callBackIdentifier)"
    [disabled]="customButtonConfig.disabled"
    [icon]="customButtonConfig.icon"
  ></oneapp-button>
  <oneapp-button
    *ngIf="customButtonConfig2"
    [id]="customButtonConfig2.id"
    [action]="buttonAction.CUSTOM"
    [text]="customButtonConfig2.text ?? ''"
    (buttonClick)="onClick(customButtonConfig2.callBackIdentifier)"
    [disabled]="customButtonConfig2.disabled"
    [icon]="customButtonConfig2.icon"
    [secondaryIcon]="customButtonConfig2.secondaryIcon"
    [type]="customButtonConfig2.type!"
  ></oneapp-button>
  <oneapp-button
    *ngIf="deleteButtonConfig"
    [id]="deleteButtonConfig.id"
    [action]="buttonAction.DELETE"
    (buttonClick)="onClick(deleteButtonConfig.callBackIdentifier)"
    [disabled]="deleteButtonConfig.disabled"
    [icon]="deleteButtonConfig.icon"
  ></oneapp-button>
  <div *ngIf="saveButtonConfig">
    <oneapp-button
      [id]="saveButtonConfig.id"
      [action]="buttonAction.SAVE"
      (buttonClick)="onClick(saveButtonConfig.callBackIdentifier)"
      [disabled]="saveButtonConfig.disabled"
      [icon]="saveButtonConfig.icon"
      [secondaryIcon]="saveButtonConfig.secondaryIcon"
      *epgIfPermitted="saveButtonConfig?.requiredPermissions ?? []"
    ></oneapp-button>
  </div>
  <div *ngIf="actionsMenuConfig">
    <button
      class="actions_menu_button"
      mat-icon-button
      [matMenuTriggerFor]="actionsMenuRef"
      [disabled]="actionsMenuConfig.disabled"
    >
      <fa-icon [icon]="faEllipsisVertical"></fa-icon>
    </button>

    <mat-menu #actionsMenuRef="matMenu" class="custom-actions-menu">
      <button
        *ngFor="let item of actionsMenuConfig.actionsMenu"
        class="actions_menu_item_button"
        mat-menu-item
        [disabled]="item.disabled"
        (click)="onClick(item.callBackIdentifier)"
      >
        <span class="actions_menu_item" [ngStyle]="item.color ? { color: item.color } : {}">
          <span class="actions_menu_item_text">{{ item.text ?? '' }}</span>
          <fa-icon *ngIf="item.icon as icon" class="actions_menu_item_icon" [icon]="icon"></fa-icon
        ></span>
      </button>
    </mat-menu>
  </div>
  <button
    mat-icon-button
    *ngIf="dismissButtonConfig"
    [id]="dismissButtonConfig.id"
    (click)="onClick(dismissButtonConfig.callBackIdentifier)"
    [disabled]="dismissButtonConfig.disabled"
  >
    <fa-icon class="icon" [icon]="faXmark" aria-label="dismiss button"></fa-icon>
  </button>
</epg-content-header>
